






















import { defineComponent, PropType } from '@vue/composition-api';
import { ValidationProvider } from 'vee-validate';
import { inputProps, useList } from '../../formUtils';
import { LabeledListItem } from '../../types';

export default defineComponent({
	components: { ValidationProvider },
	props: {
		...inputProps,
		options: {
			type: Array as PropType<LabeledListItem[]>,
			required: true,
		},
	},
	setup(props, { emit }) {
		const { currentlySelectedOption, selectValue } = useList(props, emit);

		return {
			currentlySelectedOption,
			selectValue,
		};
	},
});
